import React from "react";
import LegalLayout, { Section } from "../components/LegalLayout";
import { usePageTitle } from "../lib/usePageTitle";

export default function Privacy() {
  usePageTitle("Privacy Policy");
  return (
    <LegalLayout eyebrow="Your privacy" title="Privacy Policy" updated="February 2026">
      <Section heading="Who we are">
        <p>
          This website is operated by <strong>Alpha Media and Automations LLC</strong>, trading as
          <strong> Get Virtual Growth</strong> ("we", "us", "our"). Registered office: Meydan Grandstand,
          6th Floor, Al Meydan Road, Nad Al Sheba 1, Dubai, United Arab Emirates. The founder,
          Krishna S., works between Dubai and Spain, with time on the road across Europe through 2026.
          You can reach us any time at
          <a className="text-brass hover:underline" href="mailto:hello@GetVirtualGrowth.com"> hello@GetVirtualGrowth.com</a>.
        </p>
      </Section>
      <Section heading="What we collect">
        <p>
          We only collect what you choose to share with us through our forms: your name, email address,
          phone number, business name, website or listing, your country, the challenge you describe, and the
          answers you give in our business diagnosis. We do not ask for sensitive personal information.
        </p>
      </Section>
      <Section heading="How we use it">
        <p>
          We use your details for one purpose: to prepare your written business diagnosis and to contact you
          about it. If we ever wish to use your information for anything else, we will ask you first.
        </p>
      </Section>
      <Section heading="We never sell your data">
        <p>
          We do not sell, rent or trade your personal information to anyone. We share it only with the trusted
          systems we use to run our own business (for example, secure email and our client tools), and only to
          the extent needed to serve you.
        </p>
      </Section>
      <Section heading="Confidentiality">
        <p>
          Anything you tell us about your business is treated as strictly confidential. While we work together,
          we will not publicly reveal that you are our client, protecting your strategy and your competitive edge.
        </p>
      </Section>
      <Section heading="Your rights">
        <p>
          You may ask us at any time to access, correct or delete the personal information we hold about you, or
          to stop contacting you. Just email us and we will act promptly, in line with UAE data protection law,
          UK GDPR, the EU GDPR (relevant while the founder is based in and travelling across Europe), and the
          privacy laws of Australia, New Zealand and the United States as they apply to you.
        </p>
      </Section>
      <Section heading="Data retention & security">
        <p>
          We keep your information only for as long as needed to serve you and to meet our legal obligations,
          then we securely remove it. We take reasonable technical and organisational measures to keep your data safe.
        </p>
      </Section>
      <Section heading="Cookies">
        <p>
          This site uses only the minimum cookies required to function. If we add analytics in the future, we will
          update this policy and ask for your consent where required.
        </p>
      </Section>
      <Section heading="Contact">
        <p>
          Questions about your privacy? Write to us at
          <a className="text-brass hover:underline" href="mailto:hello@GetVirtualGrowth.com"> hello@GetVirtualGrowth.com</a>.
          Every message reaches Krishna S. directly.
        </p>
      </Section>
    </LegalLayout>
  );
}
